import { render } from "./schoolSafeVideoManager.vue?vue&type=template&id=7952687e"
import script from "./schoolSafeVideoManager.vue?vue&type=script&lang=js"
export * from "./schoolSafeVideoManager.vue?vue&type=script&lang=js"

import "./schoolSafeVideoManager.vue?vue&type=style&index=0&id=7952687e&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__